// @flow
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import qs from "query-string";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { MultiStageForm, Question } from "../components/MultiStageForm";
import { PhoneNumber, Calendly } from "../questions";
import { calculateAvmLeadScore } from "../utils/sharedAvm";
import { usePersonalInformationOnSubmit } from "./usePersonalInformationOnSubmit";
import {
  formStateUpdateAction,
  type State,
} from "../components/MultiStageForm/ducks";

import { cleanupAndRedirectToAccount } from "./FinishingUpForm";

const INTRO_CALL = "INTRO_CALL";

export const PersonalValuationForm = () => {
  const {
    onSubmit: submitCustomerOnboarding,
    errorMessage,
    setErrorMessage,
  } = usePersonalInformationOnSubmit({
    leadScore: calculateAvmLeadScore,
    redirectToAccount: true,
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const params = qs.parse(location.search);
  const formState = useSelector((state) => state.onboardingForm);
  const updateFormState = (payload: $Shape<State>) =>
    dispatch(formStateUpdateAction(payload));

  useEffect(() => {
    if (!isEmpty(params)) {
      // If we already have values in form state, that takes precedence over the
      // values from the url params.
      updateFormState({
        contactDetails: {
          email: formState.contactDetails?.email || params.email,
          name: formState.contactDetails?.name || params.name,
          phone: formState.contactDetails?.phone || params.phone,
          privacyPolicyConsent: formState.contactDetails
            ? formState.contactDetails.privacyPolicyConsent
            : params.subscribed_to_marketing_comms === "true",
        },
        phone: formState.phone || params.phone,
        address: formState.address || {
          id: params.address_id,
          label: params.address_label,
          postcode: params.postcode,
          recentlyMarketed: false,
        },
        avmValuationId: params.avm_valuation_id,
      });
    }
    updateFormState({ reasonForContact: INTRO_CALL });
  }, []);

  const onSubmit = async (state) => {
    if (state.dealId) {
      await cleanupAndRedirectToAccount(state, calculateAvmLeadScore);
      return;
    }

    await submitCustomerOnboarding(state);
  };

  return (
    <>
      <MultiStageForm
        onSubmit={onSubmit}
        submitError={errorMessage}
        setSubmitError={setErrorMessage}
        formType="get-online-valuation"
      >
        <Question
          route="/get-started/personal-valuation"
          component={PhoneNumber}
          name="phone"
          skip={({ phone, contactDetails }) =>
            Boolean(phone) || Boolean(contactDetails?.phone)
          }
        />
        <Question
          route="/get-started/personal-valuation/calendar"
          component={Calendly}
          name="calendly"
        />
      </MultiStageForm>
    </>
  );
};
